import React from 'react'
import {withStyles, Grid, IconButton, Tooltip, SvgIcon, Modal, List,ListItem} from '@material-ui/core'
import {LibraryBooks, CloseRounded, PanToolOutlined, InfoOutlined} from '@material-ui/icons';
import GameLibrary from './gameLibrary/gameLibrary'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMousePointer } from '@fortawesome/free-solid-svg-icons'
import EE from '../../../../api/eventemitter'
import yaml from 'js-yaml'
import { getUserId } from '../../../../utility/function';
import { withApollo } from 'react-apollo';
import sanitizeHtml from "sanitize-html"
import { GET_USER_ACTIVITY_RECENT,GET_GAME_OBJECT_BY_ID,GET_USER_RECENTJAMS_DATA } from '../../../../api/graphql';

const sanitizeHtmlConfig = {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p', 'h1', 'ol', 'ul', 'li', 'strike', 'u'],
    allowedAttributes: { a: ['href'] }
};
const styles = {
    wrapper:{
        position:"absolute",
        top:"3rem",
        height: "calc(100% - 3rem)",
        zIndex:"2",
        pointerEvents: "none",
    },

    menu:{
        position:"absolute",
        left:"250px",
        top:"0px",
        height:"100%",
        padding:"0 10px",
        transition:"0.5s",
        pointerEvents: "auto"
    },

    menuClose:{
        position:"absolute",
        left:"0",
        top:"0px",
        height:"100%",
        padding:"0 10px",
        transition:"0.5s",
        pointerEvents: "auto"
    },

    menuBtn:{
        marginTop:"10px",
        background:"#FFF",
        boxShadow:"0px 5px 5px #C4C4C4",
        '&:focus':{
            outline:"none",
        }
    },

    menuIcon:{
        color:"#4F4F4F",
        transition:"0.5s",
        borderRadius:"0px",
        '&:focus':{
            outline:"none",
        },
        "&:hover":{
            background:"rgba(0,0,0,0.1)"
        },
    },

    selected:{
        color:"#4173D6",
        borderRadius:"0px",
        transition:"0.5s",
        '&:focus':{
            outline:"none",
        },
        "&:hover":{
            background:"rgba(0,0,0,0.1)"
        },
    },

    content:{
        top:"0",
        overflowY:"auto",
        overflowX:"hidden",
        height:"100%",
        background: "#E1E1E1",
        width: "250px",
        position: "absolute",
        zIndex:"2",
        transition:"0.5s",
        pointerEvents: "auto"
    },

    contentClose:{
        top:"0",
        overflowY:"auto",
        marginLeft:"-250px",
        height:"100%",
        background: "#E1E1E1",
        width: "250px",
        position: "absolute",
        zIndex:"2",
        transition:"0.5s",
        pointerEvents: "auto"
    },

    close:{
        color:"#4F4F4F",
        '&:focus':{
            outline:"none",
        }
    },

    panelHeader:{
        margin:"0",
        padding:"0 1rem",
        fontWeight:"bold",
        color:"#4F4F4F",
        fontSize:"18px",
    },

    panelSubheader:{
        margin:"0",
        padding:"0 1rem",
        color:"#4F4F4F",
        fontSize:"12px",
    },

    recentModal:{
        width: "700px",
        background: "#FAF9F9",
        border: '1px solid #d1d1d1',
        fontFamily:"arial",
        padding:"2em",
        borderRadius:"5px",
        margin:"auto", 
        marginTop:"15%", 
        outline:'none'
    },
    recentModalHeader:{
        marginTop:"1.2rem",
        fontWeight:"bold",
        fontSize:"28px",
        color:"black",
        textAlign:"left",
    },

    recentPopUpBtn:{
        display:"block",
        background:"#FDAF2A",
        color:"#fff",
        borderRadius:"5px",
        width:"100%",
        padding:"0.5rem 0.5rem",
        marginTop:"0.5rem",
        fontSize: "0.875rem",
        fontWeight:"bold"
    },
}
class GameLeftPanel extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            page: null,
            open: false,
            mode: "Cursor",
            canvasFocus: true,

            canvasImport: false,
            recentGame: null,
            loader: true,
            rgSelected: null,
            preview: null,
        }
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.navigationModeShortcut.bind(this));
    }

    componentDidMount(){
        document.addEventListener("keydown", this.navigationModeShortcut.bind(this) );

        EE.on("Canvas Defocus",()=>{
            if(this.state.canvasFocus == true){
                this.setState({
                    canvasFocus: false,
                })
                this.props.clearMultiSelect();
            }
            // console.log("Canvas Defocus");
        })

        EE.on("Canvas Focus",()=>{
            if(this.state.canvasFocus == false){
                this.setState({
                    canvasFocus: true,
                })
            }
            // console.log("Canvas Focus");
        })

        EE.on("Spectator Popup",()=>{
            this.setState({
                canvasFocus: false,
            })
        })
    }

    navigationModeShortcut = (e) => {
        if(e.key === "v" && this.state.canvasFocus){
            this.navigateSelect()
        }

        // if(e.shiftKey && e.key === "T" && this.state.canvasFocus){
        //     // console.log("TR")
        //     EE.emit("Game Joyride")
        // } for tutorial shortcut

        // if(e.key === "h" && this.state.canvasFocus){
        //     this.props.updMode("Hand")
        // }

        if(e.key === '+' && this.state.canvasFocus){
            this.props.handleZoomIn();
        }

        if(e.key === '=' && this.state.canvasFocus){
            this.props.handleZoomIn();
        }

        if(e.key === '-' && this.state.canvasFocus){
            this.props.handleZoomOut();
        }

        if(e.key === '_' && this.state.canvasFocus){
            this.props.handleZoomOut();
        }

    }

    render(){
        const {page} = this.state
        const {objects, classes, updMode, cursorMode, isLeader} = this.props
        // console.log(objects)

        return(
            <div onClick={()=>{EE.emit("Canvas Defocus")}} className={classes.wrapper}>
                <div className={this.state.open ? classes.menu : classes.menuClose}>
                    <div className={classes.menuBtn}>
                        {isLeader &&
                            <Tooltip title={"Library"} placement="right">
                                <IconButton onClick={()=>this.openPanel("Library")} className={this.state.page === "Library" ? classes.selected : classes.menuIcon}>
                                    <LibraryBooks/>
                                </IconButton>
                            </Tooltip>
                        }
                        <Tooltip placement="right" title={<p style={{margin:"0"}}>Select <span style={{color:"#D1D1D1", marginLeft:"20px"}}>V</span></p>}>
                            <IconButton onClick={()=>this.navigateSelect()} className={`canvas-select ${cursorMode === "Cursor" ? classes.selected : classes.menuIcon}`} style={{padding:"0.75rem 0.5rem 0.75rem 0.5rem", width:"100%"}}>
                                {/* <FontAwesomeIcon icon={faMousePointer} style={{fontSize:"20px"}}/> */}
                                <SvgIcon>
                                    <svg width="45px" height="45px" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        {/* <path d="M0 16.015V0L11.591 11.619H4.55L4.399 11.743L0 16.015Z" fill="white" /> */}
                                        <path d="M1 2.40698V13.595L3.969 10.729L4.129 10.59H9.165L1 2.40698Z" fill={cursorMode === "Cursor" ? "#4173D6" : "#4f4f4f"}/>
                                    </svg>
                                </SvgIcon>
                            </IconButton>
                        </Tooltip>
                        {isLeader &&
                            <Tooltip title={"Import JAML"} placement="right">
                                <IconButton onClick={()=> {/*document.getElementById('jamlInput').click()*/ this.setState({canvasImport:true}); this.recentGameQuery()}} className={`canvas-select ${cursorMode === "Cursor" ? classes.selected : classes.menuIcon}`} style={{padding:"0.75rem 0.5rem 0.75rem 0.5rem", width:"100%"}}>
                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V11M1 8H19M8 1V19M17 20V14M17 14L20 17M17 14L14 17" stroke="#4F4F4F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <input
                                    id="jamlInput"
                                    type="file"
                                    accept='.jaml'
                                    style={{display:"none"}}
                                    onChange={this.handleFileUpload}
                                />
                                </IconButton>
                            </Tooltip>
                        }
                        {/*
                        <Tooltip placement="right" title={<p style={{margin:"0"}}>Hand tool <span style={{color:"#D1D1D1", marginLeft:"20px"}}>H</span></p>}>
                        <IconButton  onClick={()=>updMode("Hand")} className={cursorMode === "Hand" ? classes.selected : classes.menuIcon}>
                            <PanToolOutlined/>
                        </IconButton>
                    </Tooltip>
                        */}

                    </div>
                </div>
                <div className={this.state.open ? classes.content : classes.contentClose}  id="left-panel">
                    <div style={{margin:"10px"}}>
                        <Grid container justify="center" alignItems="center">
                            <Grid item xs={9}>
                                <div style={{display:"flex", alignItems:"center"}}>
                                    <p className={classes.panelHeader}>
                                        {this.state.page}
                                    </p>
                                    {this.state.page === "Library" &&
                                        <Tooltip
                                            placement="right"
                                            title={
                                                <span style={{fontSize:"12px"}}>
                                                    The library contains all cards in the jam including cards from the deck and on the canvas.
                                                    <br /><br />
                                                    It does not contain cards currently in jammers' own hand.
                                                </span>
                                            }
                                        >
                                            <InfoOutlined style={{fontSize:"18px", marginLeft:"-6px", color:"#828282", cursor:"pointer"}} />
                                        </Tooltip>
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={3}>
                                <IconButton className={classes.close} onClick={()=>this.closePanel()}>
                                    <CloseRounded />
                                </IconButton>
                            </Grid>
                            {/* <Grid item xs={12}>
                                {this.state.page==="Library" &&
                                    <p className={classes.panelSubheader}>
                                        List of all the cards in the jam
                                    </p>
                                }
                            </Grid> */}
                        </Grid>

                        {this.pageSelection(page, objects)}
                    </div>
                </div>
                <Modal
                    open={this.state.canvasImport}
                    onClose={()=>{this.setState({canvasImport: false})}}
                >
                    <div className={classes.recentModal}>
                        <h1 style={{lineHeight:"0"}} className={classes.recentModalHeader}>Import Canvas</h1>
                        <div style={{position:"relative", top:"-20px", left:"400px"}}>                
                            <button style={{
                                 marginLeft:"1em",
                                 color:"white",
                                 background:"white", 
                                 padding:"5px 1.5em", 
                                 borderRadius:"5px",
                                 fontSize:"14px",
                                 color:"gray",
                                 ontWeight:"bold"}}
                                 onClick={()=>{document.getElementById('jamlInput').click()}}>Upload JAML</button>
                            <button style={{border:"none",
                            marginLeft:"1em",
                                 color:"white",        
                                 background:"#fa841b", 
                                 padding:"5px 1.5em", 
                                 borderRadius:"5px",
                                 fontSize:"14px",
                                 color:"white",
                                 ontWeight:"bold"}} onClick={()=>{this.getImportGame()}}>Import</button>
                        </div>

                        <Grid container justify="center" alignItems='center'>
                            <Grid item xs={5} style={{padding:"1em"}}>
                                <input style={{width:"100%",marginBottom:"1em"}} placeholder='Find Jam'/>
                                <div style={{maxHeight: '300px', overflowY:"scroll", paddingRight:"1em"}}>
                                    {this.state.recentGame ? 
                                        <div>
                                            <List style={{}} component="nav">
                                                {this.state.recentGame.map((n,index)=>{
                                                    return(
                                                        <ListItem 
                                                            style={{backgroundColor:this.state.rgSelected === index ? '#f1e78a': '#c4c4c4', borderRadius:"5px",marginBottom:".75em"}} 
                                                            button key={index} onClick={()=>{this.setState({rgSelected: index}); this.getImportNow(index)}} 
                                                            selected={this.state.rgSelected === index}
                                                        >
                                                            <div>
                                                                <p style={{marginBottom:"2px"}}><strong>{n.name}</strong> - 👤{this.countPlayer(n.participants)}/6</p>
                                                                <p style={{marginBottom:"2px"}}>hosted by {n.createdBy.displayName}</p>
                                                            </div>
                                                        </ListItem>
                                                    )
                                                })}
                                            </List>    
                                        </div>
                                    :
                                        <div>
                                            No Jam
                                        </div>
                                    }
                                </div>
                            </Grid>
                            <Grid item xs={7}>
                                <h2 style={{color:"gray", fontWeight:"bold", paddingLeft:"1em"}}>Preview - Test Jam</h2>
                                <div style={{overflowY:"scroll",border:"1px solid grey", borderRadius:"5px", height:"300px"}}>
                                    {this.state.preview ? 
                                    
                                        <div style={{padding:"1em"}}>
                                            {this.state.preview.map((o,index)=>
                                                <ul key={index}>
                                                    <RenderOutput node={o}/>
                                                </ul>
                                            )}

                                        </div>  
                                    : <div></div>}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Modal>
            </div>
        )
    }

    countPlayer = (p) => {
        return p.length
    }

    getImportGame = () => {
        let {rgSelected,recentGame} = this.state

        let gid = recentGame[rgSelected]._id
        //console.log(rgSelected,recentGame)

        this.props.client.query({
            query: GET_GAME_OBJECT_BY_ID(gid)
        }).then((res)=>{
            //console.log(res)
            EE.emit("New Canvas Objects",{objects: res.data.gameById.data.objects})
            this.setState({
                canvasImport: false,
                rgSelected: null,
                preview: null,
            })
        })
    }

    getImportNow = (index) => {
        let gid = this.state.recentGame[index]._id

        this.props.client.query({
            query: GET_GAME_OBJECT_BY_ID(gid)
        }).then((res)=>{
            // console.log(res)
            //EE.emit("New Canvas Objects",{objects: res.data.gameById.data.objects})
            this.setState({
                preview: res.data.gameById.data.objects,
            })
        })
    }

    recentGameQuery = () => {
        let uid = getUserId()
       // console.log(uid)
        this.props.client.query({
            query: GET_USER_RECENTJAMS_DATA(uid)
        }).then((res) => {
            //console.log(res)
            const recentActivity = res.data.userById.recentJamsData.reverse()
            //console.log(recentActivity)
            this.setState({
                recentGame: recentActivity,
            })
        })
    }

    openPanel = (select) => {
        this.setState({
            open: true,
            page: select
        })
    }

    closePanel = () =>{
        this.setState({
            open: false,
            page: null
        })
    }

    navigateSelect = () => {
        let {cursorMode} = this.props
        // console.log(cursorMode)
        if(cursorMode === "Cursor"){
            this.props.updMode("Hand")
        }

        if(cursorMode === "Hand"){
            this.props.updMode("Cursor")
        }
    }



    handleCategoryClick = (category) =>{
        this.setState({
            [category]: !this.state[category]
        })
    }

    handleLabelClick = (label) =>{
        this.setState({
            [label]: !this.state[label]
        })
    }

    pageSelection = (page, objects) =>{
        switch(page){
            case "Library":
                const {
                    addNewLibraryCard,
                    moveViewToCard,
                    categoryColorMap,
                    deleteLibrary,
                    selectCardsInLibrary,
                    selectedIDs,
                    canDragLibCard,
                    isLeader,
                    startSelectCardsLibrary,
                    clearLibrarySelection,
                    duplicateSingleLibraryCard,
                } = this.props;

                return(
                    isLeader &&
                    <GameLibrary
                        objects={objects}
                        addNewLibraryCard={addNewLibraryCard}
                        moveViewToCard={moveViewToCard}
                        deleteLibrary = {deleteLibrary}
                        duplicateSingleLibraryCard={duplicateSingleLibraryCard}
                        categoryColorMap={categoryColorMap}
                        leftPanelState = {this.state}
                        handleCategoryClick = {this.handleCategoryClick}
                        handleLabelClick = {this.handleLabelClick}
                        selectCardsInLibrary = {selectCardsInLibrary}
                        selectedIDs = {selectedIDs}
                        canDragLibCard = {canDragLibCard}
                        startSelectCardsLibrary = {startSelectCardsLibrary}
                        clearLibrarySelection = {clearLibrarySelection}
                        imgData = {this.props.imgData}
                        canvasFocus = {this.state.canvasFocus}
                    />
                )
            default:
                break
        }
    }

     handleFileUpload = (event) => {
        const file = event.target.files[0];

        if(file && file.name.endsWith(".jaml")){
            const reader = new FileReader();
            reader.onload = (e) => {
                // console.log(e.target.result);
                try{
                    const data = yaml.load(e.target.result)
                    EE.emit("New Canvas Objects",{objects: data.objects})
                    // Close the Import Canvas popup once the import succeeds (mirrors getImportGame).
                    this.setState({
                        canvasImport: false,
                        rgSelected: null,
                        preview: null,
                    })
                }catch(error){
                    console.error("Error parsing the JAML file:", error)
                    alert("Failed to import: the JAML file could not be read.")
                }
            };
            reader.readAsText(file);
        }else{
            console.error("Please upload a valid JAML file.")
            alert("Please upload a valid JAML file.")
        }
    }
    
}

function RenderOutput ({node}){
    // console.log(node)
    if(node.child && node.child.length > 0){
       // console.log("in child")
        return(
            <li>
                <strong style={{color:node.categoryColor}}>{node.category}:</strong> {sanitizeHtml(node.content,sanitizeHtmlConfig)}
                <ul>
                    {node.child.map((c)=><RenderOutput node={c}/>)}
                </ul>  
            </li>
        )
    }else{
        return(
            <li>
                <strong style={{color:node.categoryColor}}>{node.category}:</strong> {sanitizeHtml(node.content,sanitizeHtmlConfig)}
            </li>
        )
    }
}

export default withApollo(withStyles(styles)(GameLeftPanel))
